import type { ArticleDetail } from '@/mocks/article';

interface AboutSectionProps {
  article: ArticleDetail;
}

export default function AboutSection({ article }: AboutSectionProps) {
  return (
    <section className="w-full bg-gradient-to-b from-[#3b2d24] to-[#2a1f18] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 bg-accent-100/20 text-accent-300 rounded-md text-xs font-medium mb-5">
              &middot; 作品详情 &middot;
            </span>
            <div className="flex items-start gap-6">
              <div className="w-28 h-40 md:w-36 md:h-52 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-heading text-5xl md:text-6xl font-bold text-white/90">
                    {article.rating}
                  </span>
                  <div className="flex flex-col">
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                    <span className="text-white/40 text-xs mt-0.5">评分</span>
                  </div>
                </div>
                <div className="space-y-1 mt-3">
                  <p className="text-white/50 text-xs">状态：<span className="text-white/80">{article.status}</span></p>
                  <p className="text-white/50 text-xs">话数：<span className="text-white/80">{article.chapters}话</span></p>
                  <p className="text-white/50 text-xs">分类：<span className="text-white/80">{article.category}</span></p>
                  <p className="text-white/50 text-xs">作者：<span className="text-white/80">{article.author}</span></p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-3/5">
            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-4">
              {article.longDescription}
            </p>
            <div className="flex flex-wrap gap-2">
              {article.tags.map((tag) => (
                <span key={tag} className="px-3 py-1 rounded-full border border-white/20 text-white/60 text-xs">
                  #{tag}
                </span>
              ))}
            </div>
            <button className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer">
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}